import {
  Component,
  ElementRef,
  OnDestroy,
  Renderer2,
  ViewChild
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Observable, Subject, Subscription } from 'rxjs';
import { withLatestFrom, filter, tap, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ReusableStreamProperty } from '@ipreo/muni-shared';
import { getLink } from '../profile-link/profile-link.component';
import { AccountService } from '../../services/account.service';
import { LoadAccountRequested } from '../../../state/profile/actions';
import { GameDayRootReducerState } from '../../../state/root.state';

export const SHADOW_WIDTH = 23;

@Component({
  selector: 'muni-gameday-profile-overview',
  templateUrl: './profile.template.html',
  styleUrls: ['./profile.styles.scss'],
  animations: [
    trigger('enterAnimation', [
      state(
        'false',
        style({
          transform: `translateX(100%) translateX(${SHADOW_WIDTH}px)`
        })
      ),
      state('true', style({ transform: 'translateX(0)' })),
      transition('true <=> false', animate('500ms ease'))
    ])
  ]
})
export class ProfileComponent implements OnDestroy {
  @ViewChild('cardsContainer')
  private cardsContainer: ElementRef;

  public readonly clickOutsideSubject = new Subject<Event>();
  public readonly boxShadow = `0 0 ${SHADOW_WIDTH}px 0 rgba(0, 0, 0, .75)`;

  @ReusableStreamProperty
  public readonly activeAccount: Observable<
    string
  > = this.accountService.activeAccount.pipe(
    filter((account: string) => !!account),
    tap(() => this.resetScroll())
  );

  @ReusableStreamProperty
  public readonly isVisible: Observable<
    boolean
  > = this.accountService.activeAccount.pipe(
    map((account: string) => !!account)
  );

  private readonly clickOutside$: Observable<
    [Event, boolean]
  > = this.clickOutsideSubject.asObservable().pipe(
    withLatestFrom(this.isVisible),
    filter(
      ([event, visible]: [Event, boolean]) =>
        visible && !getLink(event.target as Element)
    )
  );

  private readonly clickOutsideSubscription: Subscription = this.clickOutside$.subscribe(
    () => this.close()
  );

  constructor(
    private accountService: AccountService,
    private renderer: Renderer2,
    private store: Store<GameDayRootReducerState>
  ) {
    this.store.dispatch(new LoadAccountRequested());
  }

  public close(): void {
    this.accountService.resetVisibility();
  }

  public ngOnDestroy(): void {
    this.clickOutsideSubscription.unsubscribe();
  }

  private resetScroll(): void {
    this.renderer.setProperty(
      this.cardsContainer.nativeElement,
      'scrollTop',
      '0'
    );
  }
}
